<template>
  <Table
    class="goods-list"
    :data="goodsList"
    style="width: 100%"
    header-row-class-name="goods-table-header"
    row-class-name="goods-table-row"
  >
    <table-column
      :label="TLang('名称','my')"
      width="490"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.goodsType === 1">
          <span class="ticket-icon">{{ TLang('券','my') }}</span>
          <span class="ticket-type">{{ TLang('抵用券','my') }}</span>
          <a
            class="ticket-name"
            :href="scope.row.pcUrl ||
              `/birthday/goods/detail/${scope.row.goodsId}?city=${addressInfo.cityId || 145}`
            "
            target="_self"
          >{{ scope.row.goodsName }}</a>
        </div>

        <div v-else>
          <router-link
            class="ticket-name"
            :to="{
              name: 'product/detail',
              query: {
                cid: scope.row.categoryId,
                gid: scope.row.goodsId
              }
            }"
          >
            {{ scope.row.goodsName }}
          </router-link>
        </div>
      </template>
    </table-column>

    <table-column
      :label="goodsTypeName"
      width="134"
    >
      <!-- <template slot-scope="scope">
        <span
          v-if="scope.row.goodsType === 1"
        >¥{{ scope.row.faceValue ? scope.row.faceValue.toFixed(2) : 0 }}</span>
        <span
          v-else
          class="delete-line"
        >¥{{ scope.row.marketPrice ? scope.row.marketPrice.toFixed(2) : 0 }}</span>
      </template> -->
      <template slot-scope="scope">
        <span
          v-if="scope.row.goodsType === 1"
        >¥{{ scope.row.faceValue ? scope.row.faceValue.toFixed(2) : 0 }}</span>
        <span
          v-else
          :class="{'delete-line': scope.row.marketPrice > scope.row.sellingPrice}"
        >¥{{ scope.row.marketPrice > scope.row.sellingPrice ? scope.row.marketPrice.toFixed(2) : scope.row.sellingPrice.toFixed(2) }}</span>
      </template>
    </table-column>

    <table-column
      prop="sellingPrice"
      :label="`${TLang('销售价', 'my')}(${union_name || TLang('福豆', 'card')})`"
      width="200"
      class-name="goods-price"
      sortable
      :sort-method="(a, b) => a > b"
    >
      <template slot-scope="scope">
        <span>{{
          scope.row.sellingPrice ? (scope.row.sellingPrice * union_scale).toFixed(2) : 0
        }}{{ TLang('起','my') }}</span>
      </template>
    </table-column>

    <table-column
      :label="TLang('支付方式','my')"
      width="160"
    >
      {{ TLang('在线支付','my') }}
    </table-column>

    <table-column
      label=""
      width="140"
    >
      <template slot-scope="scope">
        <router-link
          v-if="scope.row.goodsType === 0"
          class="to-buy"
        
          :to="{
            name: 'product/detail',
            query: {
              cid: scope.row.categoryId,
              gid: scope.row.goodsId
            }
          }"
        >
          {{TLang('购买','my')}}
        </router-link>
        <a
          v-if="scope.row.goodsType === 1"
          class="to-buy"
          
          :href="
            `/birthday/goods/detail/${scope.row.goodsId}?city=${addressInfo.cityId || 145}`
          "
          target="_self"
        >{{TLang('购买','my')}}</a>
      </template>
    </table-column>
  </Table>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import Cookies from 'js-cookie';
export default {
  name: 'GoodsList',
  components: {
    Table,
    TableColumn,
  },

  props: {
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  data(){
    return {
      addressInfo: Cookies.get('address') && JSON.parse(Cookies.get('address') || '{}'),
    };
  },


  computed: {
    goodsTypeName() {
      if(!this.goodsList || !this.goodsList.length) return '';
      if(this.goodsList.every(item => item.goodsType === 0)){
        return TLang('市场价', 'my');
      }
      if(this.goodsList.every(item => item.goodsType === 1)){
        return TLang('面值', 'my');
      }
      return TLang('面值市场价', 'my');
    },
  },
};
</script>

<style lang="less" scoped>
.goods-list {
  border: 1px solid #ececec;
  border-bottom: none;
  margin-bottom: 35px;
  .to-buy {
    width: 100px;
    line-height: 38px;
    background: #ee0020;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    display: block;
    &:hover {
      background: #f7372e;
    }
  }
  .delete-line {
    text-decoration: line-through;
  }
  /deep/ .goods-table-header th {
    background: #ededed;
    font-size: 14px;
    color: #333;
    .cell {
      line-height: 25px;
      font-size: 14px;
      padding: 0 10px;
    }
  }
  /deep/.goods-table-row {
    line-height: 38px;
    td {
      padding: 20px 0;
    }
    .cell {
      line-height: 38px;
      font-size: 14px;
      padding: 0 10px;
      color: #333;
    }
    .goods-price {
      .cell {
        color: #ff0000;
      }
    }
    .ticket-icon {
      color: #fff;
      background: #4a9fe6;
      width: 22px;
      width: auto;
      padding: 0 4px;
      min-width: 22px;
      box-sizing: border-box;
      line-height: 22px;
      border-radius: 2px;
      display: inline-block;
      text-align: center;
      margin-right: 10px;
    }
    .ticket-type {
      color: #999;
      margin-right: 5px;
    }
    .ticket-name {
      color: #1a4a9e;
      &:hover {
        color: #ff0000;
      }
    }
  }
}
</style>
